import { useState } from "react";
import { Link } from "react-router-dom";
import api, { formatApiError } from "@/lib/api";
import { PillBottle, Loader2, MailCheck, ArrowLeft } from "lucide-react";

export const AuthShell = ({ children }) => (
  <div className="min-h-screen grid place-items-center bg-slate-50 p-6">
    <div className="w-full max-w-md">
      <Link to="/" className="flex items-center gap-2.5 justify-center mb-8">
        <div className="h-9 w-9 rounded-lg bg-indigo-600 grid place-items-center"><PillBottle className="h-5 w-5 text-white" /></div>
        <span className="font-extrabold text-slate-900">PharmaGroup</span>
      </Link>
      <div className="bg-white border border-slate-200 rounded-2xl p-8">{children}</div>
      <Link to="/login" className="mt-5 flex items-center justify-center gap-1.5 text-sm font-semibold text-indigo-600 hover:underline" data-testid="back-to-login"><ArrowLeft className="h-4 w-4" /> Retour à la connexion</Link>
    </div>
  </div>
);

export const authInput = "mt-1.5 w-full h-11 px-3.5 rounded-lg border border-slate-300 bg-white focus:outline-none focus:ring-2 focus:ring-indigo-600 transition-shadow";

export default function ForgotPassword() {
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [msg, setMsg] = useState("");
  const [error, setError] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      const { data } = await api.post("/auth/forgot-password", { email });
      setMsg(data.message);
    } catch (err) { setError(formatApiError(err.response?.data?.detail)); }
    finally { setLoading(false); }
  };

  return (
    <AuthShell>
      {msg ? (
        <div className="text-center" data-testid="forgot-success">
          <MailCheck className="h-12 w-12 text-emerald-500 mx-auto" />
          <h1 className="mt-4 text-xl font-extrabold text-slate-900">Vérifiez votre boîte mail</h1>
          <p className="mt-2 text-sm text-slate-500 font-medium">{msg}</p>
        </div>
      ) : (
        <>
          <h1 className="text-2xl font-extrabold tracking-tight text-slate-900">Mot de passe oublié</h1>
          <p className="text-slate-500 font-medium mt-1 text-sm">Saisissez votre email, nous vous envoyons un lien pour en choisir un nouveau.</p>
          <form onSubmit={submit} className="mt-6 space-y-4">
            <div>
              <label className="text-sm font-semibold text-slate-700">Email</label>
              <input data-testid="forgot-email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={authInput} placeholder="vous@pharmacie.tn" />
            </div>
            {error && <div data-testid="forgot-error" className="text-sm font-medium text-red-600 bg-red-50 border border-red-200 rounded-lg px-3 py-2">{error}</div>}
            <button data-testid="forgot-submit" disabled={loading} className="w-full h-11 rounded-lg bg-indigo-600 hover:bg-indigo-700 text-white font-semibold flex items-center justify-center gap-2 transition-colors duration-200 disabled:opacity-60">
              {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : "Envoyer le lien"}
            </button>
          </form>
        </>
      )}
    </AuthShell>
  );
}
